import React from 'react'
import Image from '../Image'

const Showcase = ({ imageSrc }) => {
  return (
    <div className="z-10">
      <Image src={imageSrc} className="w-80 h-80 rounded-full object-cover" alt="Showcase item" />
    </div>
  )
}

export default Showcase